module.exports = __webpack_public_path__ + "img/Agrobank.9838de51.png";